export enum Permission {
    // Home
    Home = 'a:home',

    // Customer
    Customer = 'a:customer',
    CustomerAdd = 'a:customer:add',
    CustomerModify = 'a:customer:modify',
    CustomerDetails = 'a:customer:details',
    CustomerKYC = 'a:customer:kyc',
    CustomerKYCModify = 'a:customer:kyc:modify',
    CustomerChangeStatus = 'a:customer:changestatus',
    CustomerIdentifications = 'a:customer:identifications',
    CustomerIdentificationsModify = 'a:customer:identifications:modify',
    CustomerAccounts = 'a:customer:accounts',
    CustomerAccountsAdd = 'a:customer:accounts:add',
    CustomerAccountsLinkCard = 'a:customer:accounts:linkcard',
    CustomerAccountsChangeStatus = 'a:customer:accounts:changestatus',
    CustomerAccountsBalanceLimit = 'a:customer:accounts:balancelimit',
    CustomerAccountsBalanceLimitAdd = 'a:customer:accounts:balancelimit:add',
    CustomerAccountsBalanceLimitModify = 'a:customer:accounts:balancelimit:modify',
    CustomerAccountsCounts = 'a:customer:accounts:counts',
    CustomerCards = 'a:customer:cards',
    CustomerCardsAdd = 'a:customer:cards:addcards',
    CustomerCardsChangeStatus = 'a:customer:cards:changestatus',
    CustomerAccountLoadFunds = 'a:customer:accounts:load',
    CustomerAccountUnloadFunds = 'a:customer:accounts:unload',
    CustomerCardsCardDetails = 'a:customer:cards:carddetails',
    CustomerCardsCardDetailsModify = 'a:customer:cards:carddetails:modify',
    CustomerCardsSensitiveData = 'a:customer:cards:cardsensitivedata',
    CustomerCardsAuthSetting = 'a:customer:cards:authsetting',
    CustomerCardsAuthSettingModify = 'a:customer:cards:authsetting:modify',
    CustomerCardsVelocityLimits = 'a:customer:cards:velocitylimits',
    CustomerCardsVelocityLimitsModify = 'a:customer:cards:velocitylimits:modify',
    CustomerCardsVelocityLimitsCreate = 'a:customer:cards:velocitylimits:create',
    CustomerCardsTransactions = 'a:customer:cards:transactions',
    CustomerCardsReplaceCard = 'a:customer:cards:replacecard',
    CustomerCardsMarkRenewal = 'a:customer:cards:markrenewal',
    CustomerCardsAllowedMCCs = 'a:customer:cards:allowedmccs',
    CustomerCardsAllowedCountries = 'a:customer:cards:allowedcountries',

    // Product Management
    ProductManagement = 'a:productmgmt',
    CardProducts = 'a:productmgmt:cardproducts',
    CardProductsCreate = 'a:productmgmt:cardproducts:create',
    CardProductsModify = 'a:productmgmt:cardproducts:modify',
    CardProductsLinkBalanceLimit = 'a:productmgmt:cardproducts:linkbalancelimit',
    CardProductsLinkFeePlans = 'a:productmgmt:cardproducts:linkfeeplans',
    CardProductsVelocityLimit = 'a:productmgmt:cardproducts:velocitylimit',
    BalanceLimits = 'a:productmgmt:balancelimits',
    BalanceLimitsCreate = 'a:productmgmt:balancelimits:create',
    BalanceLimitsModify = 'a:productmgmt:balancelimits:modify',
    FeePlans = 'a:productmgmt:feeplans',
    FeePlansCreate = 'a:productmgmt:feeplans:create',
    FeePlansModify = 'a:productmgmt:feeplans:modify',
    Charges = 'a:productmgmt:charges',
    ChargesModify = 'a:productmgmt:charges:modify',
    VelocityLimits = 'a:productmgmt:velocitylimits',
    VelocityLimitsCreate = 'a:productmgmt:velocitylimits:create',
    VelocityLimitsModify = 'a:productmgmt:velocitylimits:modify',

    // Access Management
    AccessManagement = 'a:accessmgmt',
    Roles = 'a:accessmgmt:roles',
    RolesCreate = 'a:accessmgmt:roles:create',
    RolesModify = 'a:accessmgmt:roles:modify',
    Admins = 'a:accessmgmt:admins',
    AdminsCreate = 'a:accessmgmt:admins:create',
    AdminsModify = 'a:accessmgmt:admins:modify',
    AdminsResetPasswordAll = 'a:accessmgmt:admins:resetpassword:all',
    AdminsResetPassword = 'a:accessmgmt:admins:resetpassword',
    PasswordPolicy = 'a:accessmgmt:passwordpolicy',
    PasswordPolicyCreate = 'a:accessmgmt:passwordpolicy:create',
    PasswordPolicyModify = 'a:accessmgmt:passwordpolicy:modify',

    // SDK Settings
    SDKSettings = 'a:sdksettings',
    SDKSettingsCreate = 'a:sdksettings:create',
    SDKSettingsModify = 'a:sdksettings:modify',

    // OTP Settings
    OTPSettings = 'a:otpsettings',
    OTPSettingsCreate = 'a:otpsettings:create',
    OTPSettingsModify = 'a:otpsettings:modify',

    // Channel Settings
    ChannelSettings = 'a:channelsettings',
    ChannelSettingsCreate = 'a:channelsettings:create',
    ChannelSettingsModify = 'a:channelsettings:modify',

    // Tickets
    Tickets = 'a:tickets',
    TicketsCreate = 'a:tickets:create',
    TicketsModifyAll = 'a:tickets:modify:all',
    TicketsModify = 'a:tickets:modify',
    TicketsDelete = 'a:tickets:delete',
    TicketsRoles = 'a:tickets:roles',

    // Settings
    Settings = 'a:settings',
    Logo = 'a:logo',
    LogoCreate = 'a:logo:create',
    LogoModify = 'a:logo:modify',
    CardDesign = 'a:settings:carddesign',
    CardDesignCreate = 'a:settings:carddesign:create',
    CardDesignModify = 'a:settings:carddesign:modify',
    SettingsAvatar = 'a:settings:avatar',
    SettingsAvatarCreate = 'a:settings:avatar:create',

    // Reports
    Reports = 'a:reports',
    AllowedCountries = 'a:allowedcountries',

    // Allowed lists
    AllowedMCCs = 'a:allowedmccs',
    AllowedMCCsCreate = 'a:reports:allowedmccs:create',
    AllowedMCCsModify = 'a:reports:allowedmccs:modify',

    // Product Settings
    ProductSettings = 'a:productsettings',
    FeePlansProductSettings = 'a:productsettings:feeplans',
    FeePlansProductSettingsCreate = 'a:productsettings:feeplans:create',
    FeePlansProductSettingsModify = 'a:productsettings:feeplans:modify',
    ChargesProductSettings = 'a:productsettings:charges',
    ChargesProductSettingsCreate = 'a:productsettings:charges:create',
    ChargesProductSettingsModify = 'a:productsettings:charges:modify',
    VelocityLimitsProductSettings = 'a:productsettings:velocitylimits',
    VelocityLimitsProductSettingsCreate = 'a:productsettings:velocitylimits:create',
    VelocityLimitsProductSettingsModify = 'a:productsettings:velocitylimits:modify',
    BalanceLimitsProductSettings = 'a:productsettings:balancelimits',
    BalanceLimitsProductSettingsCreate = 'a:productsettings:balancelimits:create',
    BalanceLimitsProductSettingsModify = 'a:productsettings:balancelimits:modify',
    AdvanceVelocityLimitsProductSettings = 'a:productsettings:advancevelocitylimits',
    AdvanceVelocityLimitsProductSettingsCreate = 'a:productsettings:advancevelocitylimits:create',
    AdvanceVelocityLimitsProductSettingsModify = 'a:productsettings:advancevelocitylimits:modify',
    NotificationTemplatesProductSettings = 'a:productsettings:notificationtemplates',
    NotificationTemplatesProductSettingsCreate = 'a:productsettings:notificationtemplates:create',
    NotificationTemplatesProductSettingsModify = 'a:productsettings:notificationtemplates:modify',
    WebhooksProductSettings = 'a:productsettings:webhooks',
    WebhooksProductSettingsCreate = 'a:productsettings:webhooks:create',
    WebhooksProductSettingsModify = 'a:productsettings:webhooks:modify',
    MCCGroupProductSettings = 'a:productsettings:mccgroup',
    OTPSettingsProductSettings = 'a:productsettings:otpsettings',
    OTPSettingsProductSettingsCreate = 'a:productsettings:otpsettings:create',
    OTPSettingsProductSettingsModify = 'a:productsettings:otpsettings:modify',

    // Transactions
    Transactions = 'a:transactions',
    TransactionDetails = 'a:transactions:details',

    // Card Designs
    CardDesigns = 'a:carddesign',
    CardDesignsCreate = 'a:carddesign:create',
    CardDesignsModify = 'a:carddesign:modify',

    // Card Details
    Cards = 'a:cards',
    CardChangeStauts = 'a:cards:changestatus',
    CardDetails = 'a:cards:carddetails',
    CardDetailsModify = 'a:cards:carddetails:modify',
    CardAccountStatement = 'a:cards:accountStatement',

    // Bulk Upload
    BulkUpload = 'a:bulkload',
    BulkUploadFileUpload = 'a:bulkload:fileupload',
    BulkUploadFileData = 'a:bulkload:filedata',
    BulkUploadExecuteData = 'a:bulkload:executeload',

    // Locations
    Locations = 'a:locations',
    LocationsCreate = 'a:locations:create',
    LocationsDelete = 'a:locations:delete',
    LocationsUpdate = 'a:locations:update',
}
